import * as Yup from 'yup';

import { PhoneNumberInput } from '__generated__/globalTypes';
import { PHONE_INPUT_SCHEMA } from 'schemas/validations/phone';

export const PHONE_FIELDSET_SCHEMA = Yup.array<PhoneNumberInput>(
  PHONE_INPUT_SCHEMA.required()
);
